import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PebbleSpinner } from './pebble-spinner';
import styled from 'styled-components';
import spacing from 'theme/spacing';
const LoaderContainer = styled.div `
  position: relative;
  margin: 0 auto 0;
  align-items: center;
  flex-grow: 1;
  justify-content: center;
  display: flex;
  text-align: center;
  flex-direction: column;
  gap: 12px;
  margin: ${spacing.spacing16} 0;
`;
const LoadingText = styled.div `
  font-size: 20px;
  font-weight: 500;
  margin-top: ${spacing.spacing12};
`;
export const Loader = ({ loaderText, size }) => {
    return (_jsxs(LoaderContainer, { children: [_jsx(PebbleSpinner, { size: size }), loaderText && _jsx(LoadingText, { children: loaderText })] }));
};
